import type { BundledPackageStateToLodgingId } from "@b2bportal/core-packages";
import { CallState } from "@b2bportal/core-types";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { fetchPackageHotelAvailability } from "../thunks/hotels/fetchPackageHotelAvailability";
import { fetchPackageHotelShop } from "../thunks/hotels/fetchPackageHotelShop";
import type {
  PackageHotelState,
  TPackagesByLodgingId,
  TPackagesByRateId,
} from "../types/packagesHotels";
import { initialHotelState } from "../types/packagesHotels";

// Re-export types for backwards compatibility
export type { TPackagesByLodgingId, TPackagesByRateId, PackageHotelState };

export const packageHotelSlice = createSlice({
  name: "package/hotel",
  initialState: initialHotelState,
  reducers: {
    setPackageStateByLodgingId: (
      state,
      action: PayloadAction<BundledPackageStateToLodgingId>
    ) => {
      if (
        state.availability.data &&
        state.availability.data.packagesByLodgingId
      ) {
        state.availability.data.packagesByLodgingId = {
          ...state.availability.data.packagesByLodgingId,
          ...action.payload,
        };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPackageHotelAvailability.pending, (state) => {
        state.availability.state = CallState.InProcess;
      })
      .addCase(fetchPackageHotelAvailability.fulfilled, (state, action) => {
        state.availability.state = CallState.Success;
        state.availability.data = action.payload;
      })
      .addCase(fetchPackageHotelAvailability.rejected, (state) => {
        state.availability.state = CallState.Failed;
      })
      .addCase(fetchPackageHotelShop.pending, (state) => {
        state.shop.state = CallState.InProcess;
      })
      .addCase(fetchPackageHotelShop.fulfilled, (state, action) => {
        state.shop.state = CallState.Success;
        state.shop.data = {
          ...state.shop.data,
          ...action.payload,
        };
      })
      .addCase(fetchPackageHotelShop.rejected, (state) => {
        state.shop.state = CallState.Failed;
      });
  },
});

export const PackageHotelActions = packageHotelSlice.actions;
export default packageHotelSlice.reducer;
